import { format } from 'date-fns'
import { SessionMembers } from '../../../../../remote/types/session-members'

const formatDateSession = (date: any) => format(date, 'yyyy-MM-dd HH:mm')

export const parseSession = (data: SessionMembers) => {
  try {
    return {
      data,
      id: data.id,
      title: data.nome,
      start: formatDateSession(new Date(data.inicioAula)),
      end: formatDateSession(new Date(data.fimAula)),
      _options: {
        disableResize: true
      },
      description: data.descricao,
      calendarId: data.cor
    }
  } catch (error) {
    console.error('Error parsing session data:', data)
    throw new Error(error as any)
  }
}
